// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"868b959d","502":"295ba5a4"}[chunkId] + ".chunk.css";
};